import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './styles/index.css';
import { applyRedesignPalette } from './utils/featureFlags';
import { installChunkReloadGuard } from './bootstrap/chunkReload';

// Portable rollout-safety (docs/FRONTEND_ASSET_DELIVERY_DESIGN.md, Layer 1c):
// arm the stale-chunk auto-reload guard before the app renders, so a tab opened
// against a prior build recovers cleanly when a lazy chunk hash is gone.
installChunkReloadGuard();

// Reflect the active /flags "Redesign" palette onto <html data-redesign>
// before first paint, so the re-bound --v2-* tokens apply immediately.
applyRedesignPalette();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
